// app更新
import api from 'Plugins/api'
import { localget } from 'Utils/storage.js'
import { isH5,isAndroid,isIOS} from 'CommonUtils/plus.js'
import { Dialog } from 'vant'

export const update = (tips) => {
  if (isH5()) {//h5
    return
  }
  let state = localget('VUEX_STATE') || {}
  let compaySuper=''
  if (state.app && state.app.loginConfig) {
    compaySuper =state.app.loginConfig.compaySuper
  } else { 
    return
  }
  var wgt=false
  var wgtVersion=''
  var version = plus.runtime.version

  function downloader (url) { 
    var watiting = plus.nativeUI.showWaiting('开始下载：0%')
    var dtask = plus.downloader.createDownload(url, {method: 'GET'})
    dtask.addEventListener('statechanged', function(task) {//入参(task, status)
      if (!dtask) {
        return
      }
      switch (task.state) {
        case 1: // 开始
          break
        case 2: // 已连接到服务器
          break
        case 3: // 已接收到数据
          var nowData = Math.floor(task.downloadedSize * 100 / task.totalSize)
          if (nowData % 10 == 0) {
            watiting.setTitle('已下载：' + nowData + '%')
            if (nowData == 100) {
              if (wgt) {
              //资源安装包（wgt）
                plus.runtime.install(dtask.filename, {force:true}, function (widgetInfo) {
                  console.log(widgetInfo)
                  plus.nativeUI.toast('应用资源已更新,正在重新进入应用！')
                  // plus.runtime.quit()
                  plus.runtime.restart()
                }, function (error) { 
                  plus.nativeUI.toast(error.message)
                })
              } else { 
                plus.nativeUI.toast('正在准备环境，请稍后！')
                plus.runtime.openFile(dtask.filename)
                plus.runtime.quit()
              }
              plus.nativeUI.closeWaiting()
            }
          }
          break
        case 4: // 下载完成
          break
      }
    })
    dtask.start()
  }
    
  // 获取本地应用资源版本号  
  plus.runtime.getProperty(plus.runtime.appid,function(inf){
    wgtVersion=inf.version
  })

  api['app/getAppUrl']({
    appType :(isAndroid())?1:2, // 10505/ios
    compId:compaySuper,
    appVersion:version
  }).then(res => { 
    var cache = res.data || {}
    if (cache.appUrl) {
      wgt=cache.appUrl.indexOf('.wgt')>=0?true:false
    } else {
      return
    }
    console.log('wgt++++'+wgt)
    console.log('wgtVersion++++'+wgtVersion)
    console.log('version++++'+version)
    console.log('appVersion++++'+cache.appVersion)
    console.log('needUpdate++++'+cache.needUpdate)
    console.log('needForceUpdate++++'+cache.needForceUpdate)
    if (wgt) {//资源更新
      if (cache.appVersion > wgtVersion) {
        Dialog.alert({
          title: '更新提示',
          message: '检测到应用资源需更新，资源版本号:' + cache.appVersion+'\n'+cache.appRemark,
        }).then(() => {
          downloader(cache.appUrl)
        })
      }
    } else if (cache.needUpdate == 1 && cache.needForceUpdate == 1) {//app更新 是否需要更新 //是否强制更新
      Dialog.alert({
        title: '更新提示',
        message: '发现新版本:'+cache.appVersion+'(当前版本:'+version+')\n'+cache.appRemark,
      }).then(() => {
        if(isAndroid()){
          downloader(cache.appUrl)
        } else if (isIOS()) {
          plus.runtime.openURL(cache.appUrl)
        }
      })
    } else if (cache.needUpdate == 1 && cache.needForceUpdate == 0) {//app更新 
      Dialog.confirm({
        title: '更新提示',
        message: '发现新版本:'+cache.appVersion+'(当前版本:'+version+')\n'+cache.appRemark,
        confirmButtonText:'更新',
        cancelButtonText:'稍后',
      }).then(() => {
        // on confirm
        if (isAndroid()) {
          downloader(cache.appUrl)
        } else if (isIOS()) {
          plus.runtime.openURL(cache.appUrl)
        }
      }).catch(() => {
        // on cancel
      })
    } else if (tips) {//无需更新 
      Dialog.alert({
        title: '提示',
        message: '当前已经是最新版本',
      }).then(() => {
      })
      return
    }
  })
    
  // 获取应用信息
  // function getAppInfo () {
  // 	// 获取本地应用资源版本号
  // 	plus.runtime.getProperty( plus.runtime.appid, function ( wgtinfo ) {
  // 	//appid属性
  // 		var wgtStr = 'appid:'+wgtinfo.appid
  // 		//version属性
  // 		wgtStr += '<br/>version:'+wgtinfo.version
  // 		//name属性
  // 		wgtStr += '<br/>name:'+wgtinfo.name
  // 		//description属性
  // 		wgtStr += '<br/>description:'+wgtinfo.description
  // 		//author属性
  // 		wgtStr += '<br/>author:'+wgtinfo.author
  // 		//email属性
  // 		wgtStr += '<br/>email:'+wgtinfo.email
  // 		//features 属性
  // 		wgtStr += '<br/>features:'+wgtinfo.features
  // 		console.log(wgtStr)
  // 		plus.nativeUI.toast('已更新,当前版本：'+wgtinfo.version)
  // 	} )
  // }
}
